module.exports = __webpack_public_path__ + "media/images/ic-chat-branco-42af8d1678345b46e9eab640dc1acfd8.svg";